export const CANONICAL_WEB_ORIGIN = 'https://tidyping.com'

export function canonicalProductionURL(
  currentURL: string,
  isProduction = import.meta.env.PROD,
) {
  if (!isProduction) return null

  const current = new URL(currentURL)
  if (current.origin === CANONICAL_WEB_ORIGIN) return null

  return `${CANONICAL_WEB_ORIGIN}${current.pathname}${current.search}${current.hash}`
}

export function authCallbackURL(
  currentOrigin = window.location.origin,
  isProduction = import.meta.env.PROD,
) {
  const origin = isProduction ? CANONICAL_WEB_ORIGIN : currentOrigin
  return new URL('/auth/callback', origin).toString()
}
